import { render, staticRenderFns } from "./paymentLink.vue?vue&type=template&id=0b55e4fd&scoped=true"
import script from "./paymentLink.vue?vue&type=script&lang=js"
export * from "./paymentLink.vue?vue&type=script&lang=js"
import style0 from "./paymentLink.vue?vue&type=style&index=0&id=0b55e4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55e4fd",
  null
  
)

export default component.exports